import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { computed, onMounted } from 'vue';
import { useHeziStore } from '@remote/store/hezi';
import { useDeviceStore } from '@remote/store/device';
export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceIndicator',
  setup(__props) {
    const deviceStore = useDeviceStore();
    const curDeviceRunner = computed(() => {
      var _deviceStore$currentD;
      return (_deviceStore$currentD = deviceStore.currentDeviceRef) === null || _deviceStore$currentD === void 0 ? void 0 : _deviceStore$currentD.runnerTaskRef;
    });
    const currentStatus = computed(() => {
      var _curDeviceRunner$valu;
      return ((_curDeviceRunner$valu = curDeviceRunner.value) === null || _curDeviceRunner$valu === void 0 ? void 0 : _curDeviceRunner$valu.phase) === 'PHASE_TYPE_RUNNING';
    });
    const currentName = computed(() => {
      var _curDeviceRunner$valu2;
      return (_curDeviceRunner$valu2 = curDeviceRunner.value) === null || _curDeviceRunner$valu2 === void 0 ? void 0 : _curDeviceRunner$valu2.name;
    });
    const heziStore = useHeziStore();
    onMounted(() => {
      heziStore.getHezi();
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(['current-device', currentStatus.value ? 'active' : ''])
      }, [_createElementVNode("span", null, _toDisplayString(currentName.value ? currentName.value : '获取设备状态中'), 1)], 2);
    };
  }
});